import React, { useState, useEffect } from "react";
import { Space, Col, Row } from "antd";
import { useMediaQuery } from "react-responsive";
import Request from "../../helpers/Request";

const Campaigns = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    Request("../campaigns", "GET").then((response) => {
      console.log(response.data);
      setCampaigns(response.data);
    });
  }, []);

  return (
    <>
      <div className="margin-100-zero" style={{
        textAlign: "center",
        paddingLeft: isMobileScreen ? "10px" : "100px",
        paddingRight: isMobileScreen ? "10px" : "100px",
      }}>
        {campaigns.length > 0 && (
          <div className="reviews-section">
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div style={{
                  fontSize: 36,
                  color: "#2D3948",
                  fontFamily: "Trenda-bold"
                }}>
                  {"Pasiūlymai"}
                </div>
              </Col>
              {campaigns.map((campaign, index) => (
                <Col key={index} xs={24} sm={24} md={12} lg={8} xl={8}>
                  <div className="review-card">
                    <div className="review-card-body" style={{
                      display: "flex",
                      height: "100%",
                      flexDirection: "column",
                    }}>
                      <div className="review-card-name">
                        {campaign.name}
                      </div>
                      <a href={`../campaigns/${campaign.url}`} style={{
                        marginTop: "auto",
                      }}>
                        <button className="btn btn-primary-alsendo btn-circle btn-lg">
                          {"Peržiūrėti"}
                        </button>
                      </a>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </div>
    </>
  );
};

export default Campaigns;
